// import Reac, { useEffect } from 'react';
import { Button, Paper, Box, TextField, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import AgGridPaginatedTable from "../../components/AgGridPaginatedTable.jsx";
import { useEffect, useState } from "react";
import { getCases } from "../../api/cases.js";
import { casesTable } from "../../config/grid-column-defs.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";

export default function ListCases() {
  const { data: user } = useSelector((state) => state.user);
  const handleError = useErrorHandler();
  const [filterTittle, setTittleFilter] = useState("");
  const [filterType, setTypeFilter] = useState("");
  const [caseTableRefreshCount, setCaseTableRefreshCount] = useState(0);
  function refreshUsersTable() {
    setCaseTableRefreshCount((prev) => prev + 1);
  }
  async function getCaseTableData(limit, offset) {
    try {
      const { data } = await getCases(user.token, {
        limit,
        offset,
        title: filterTittle,
        type: filterType,
      });
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      handleError(error);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  useEffect(() => {
    refreshUsersTable();
  }, [filterTittle, filterType]);
  return (
    <>
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Grid
            container
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} sm={3} md={4} lg={5}>
              <Typography className="heading-title">Cases</Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={5} lg={5}>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 1, md: 1 }}
              >
                <Grid item xs={6} sm={6} md={6}>
                  <TextField
                    size="small"
                    // className={classes.textfeild}
                    labelid="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Title"
                    value={filterTittle}
                    onChange={(e) => {
                      setTittleFilter(e.target.value);
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <TextField
                    size="small"
                    // className={classes.textfeild}
                    labelid="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Type"
                    value={filterType}
                    onChange={(e) => {
                      setTypeFilter(e.target.value);
                    }}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={3} md={3} lg={2}>
              <Link to="/cases/new">
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  className="blue-button"
                  fullWidth
                >
                  Create Case
                </Button>
              </Link>
              {/* {loading ? <CircularProgress /> : <></>} */}
            </Grid>
          </Grid>
        </Box>
        <div className="odr-main-table">
          <AgGridPaginatedTable
            getTableRows={getCaseTableData}
            columns={casesTable}
            perPage={10}
            refreshCounter={caseTableRefreshCount}
          />
        </div>
      </Paper>
    </>
  );
}
